import React from 'react'
import {ReactComponent as ArrowLeft} from '../../assets/icons/arrow-left.svg'
const ArrowLeftIcon = () => {
    return (
        <div>
            <ArrowLeft />
        </div>
    )
}

export default ArrowLeftIcon
